// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ProjectRequestProcessor } from './project-request.processor';

@Injectable({providedIn: 'root'})
export class ProjectRequestProcessorDelegator {

  private _projectRequestProcessor: ProjectRequestProcessor;

  public set projectRequestProcessor(value: ProjectRequestProcessor) {
    this._projectRequestProcessor = value;
  }

  public saveProjectSucceeded() {
    this._projectRequestProcessor.saveProjectSucceeded();
  }
}
